let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dnrR3")).then(() => parcelRequire('jB3l2'));